<ion-header class="ion-no-border">
  <ion-toolbar class="ion-no-padding">
    <mom-progress-logo slot="start" [progress]="index === 0 ? 100 : progress"></mom-progress-logo>
    <ion-text *ngIf="index > 0" class="ion-margin-start">{{ index }} of {{ count }}</ion-text>
    <ion-buttons slot="end">
      @if (description){
      <ion-button [id]="'open_info-' + index" color="secondary" expand="block" mode="md">
        <fa-icon slot="end" size="lg" [icon]="faInfoCircle"></fa-icon>
      </ion-button>

      <ion-modal #modal [trigger]="'open_info-' + index" class="description-card" [breakpoints]="[0, 1]" [initialBreakpoint]="1">
        <ng-template>
          <ion-header>
            <ion-toolbar>
              <ion-title>Helpful guide</ion-title>
              <ion-buttons slot="end">
                <ion-button color="primary" mode="md" (click)="modal.dismiss()">Close</ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-header>
          <ion-content class="ion-padding">
            <ion-text>
              <h1>What does this mean?</h1>
            </ion-text>
            <p [innerHtml]="description"></p>
          </ion-content>
        </ng-template>
      </ion-modal>
      }
    </ion-buttons>
  </ion-toolbar>
</ion-header>
